<script>
export default {
    name: "PopupClose"
}
</script>
<template>
    <svg id="Group_1265" data-name="Group 1265" xmlns="http://www.w3.org/2000/svg" width="76.398" height="76.398" viewBox="0 0 76.398 76.398">
        <path id="Path_30" data-name="Path 30" d="M37.825,64.528,37.738.087,33.711,7.018,0,64.528V0" transform="translate(19.287 5.935)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
        <path id="Path_34" data-name="Path 34" d="M0,64.528V0L4.114,7.018l33.711,57.51" transform="translate(19.287 5.935)" fill="none" stroke="#fff" stroke-linejoin="round" stroke-width="1"/>
        <g id="Ellipse_81" data-name="Ellipse 81" transform="translate(0 0)" fill="none" stroke="#fff" stroke-width="1">
            <ellipse cx="38.199" cy="38.199" rx="38.199" ry="38.199" stroke="none"/>
            <ellipse cx="38.199" cy="38.199" rx="37.699" ry="37.699" fill="none"/>
        </g>
    </svg>
</template>